//
import { mapActions } from "vuex"
import { ModelForm } from "@/components/reusable_components/next"
import Translator from "@/services/translator"

//
import PosCashDeskModel from "@/models/POS/PosCashDesk"
import fields from "./fields"

//
export default {
    name: "role-update",
    components: {
        "model-form": ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                editable: true,
                fields: fields,
                switchEdit: true,
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setAppToolbarTitle: "setAppToolbarTitle",
        }),

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( PosCashDeskModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "role-list" })
        },

        /**
         * 
         */
        refresh () {
            this.reset()
        },

        /**
         * 
         */
        reset () {
            PosCashDeskModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },

        /**
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.update )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Caja actualizada." )
        },

        /**
         * 
         */
        update ( model ) {
            model.toUpdate().save().then( this.success ).then( this.refresh ).catch( this.error ).then( this.$refs.form.setWait )
        },
    },
    beforeMount () {
        this.setAppToolbarTitle({ title: "Datos de caja" })
    },
    mounted () {
        this.reset()
    }
}